



























































































import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';

import SidebarNavItem from './SidebarNavItem.vue';
import StudioLogo from '@/web/components/navigation/StudioLogo.vue';
import { getStudioURL } from '@/web/router/custom-domain-utils';
import { isOfficialDomain, replaceURLWithCurrentDomain } from '@/web/utils/url';
import ViewAsTeacherFooter from '@/web/components/navigation/ViewAsTeacherFooter.vue';

export default Vue.extend({
  name: 'StudioMobileProfileMenu',
  components: {
    SidebarNavItem,
    StudioLogo,
    ViewAsTeacherFooter,
  },
  data() {
    return {
      isUserCollapseOpen: true,
    };
  },
  computed: {
    ...mapGetters({
      studio: 'studio/currentStudio',
      numberOfThisStudioPunches: 'user/numberOfThisStudioPunches',
      numberOfNotifications: 'community/numberOfNotifications',
      isLoggedIn: 'user/isLoggedIn',
      teacherMagicCode: 'user/teacherMagicCode',
      isPWA: 'globals/isPWA',
    }),
    ...mapState('user', ['user', 'teacher']),
    ...mapState('globals', ['isStudioMobileProfileMenuOpen']),
    getBaseFrontendURL() {
      const host = window.location.host.toLowerCase();
      if (isOfficialDomain(host)) {
        return replaceURLWithCurrentDomain(window.location.origin);
      }

      return process.env.VUE_APP_FRONTEND_BASE_URL;
    },
    userName() {
      if (!this.user) return;
      return this.user.user_full_name;
    },
    studioURL() {
      return getStudioURL(this.$route);
    },
    dashboardLink() {
      return `${this.getBaseFrontendURL}dashboard?magic_code=${this.teacherMagicCode}`;
    },
  },
  methods: {
    closeMainNav() {
      this.$store.dispatch('globals/openStudioMobileProfileMenu', false);
    },
    showLogin() {
      this.$emit('login');
    },
    logout() {
      const currentRoute = this.$router.currentRoute;
      if (currentRoute.matched.some(record => record.meta.requiresAuth)) {
        this.$router.push({ name: 'studio-logout' });
      } else this.$store.dispatch(`user/logout`);

      this.closeMainNav();
    },
  },
});
